import container from 'src/container';
import useSWR from 'swr';

const {
    cradle: { munduClient },
} = container;

type UseNextOfKinsOptions = {
    organizationId?: string;
    consumerId?: string;
};

export const useNextOfKins = ({
    organizationId,
    consumerId,
}: UseNextOfKinsOptions) => {
    let swrKey: string[] | null = null;

    if (organizationId && consumerId) {
        swrKey = [
            organizationId,
            consumerId,
            'nextOfKin/organizationId/consumerId',
        ];
    } else if (organizationId) {
        swrKey = [organizationId, 'nextOfKin/organizationId'];
    } else if (consumerId) {
        swrKey = [consumerId, 'nextOfKin/consumerId'];
    }

    return useSWR(swrKey, () =>
        munduClient.listNextOfKins({ consumerId, organizationId }),
    );
};
